import { range } from 'lodash';
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchGet, fetchPost } from '../../../store/fetch';
import { Modal } from '../../common/Modal/Modal';
import { EditPanelButton, EditPanelButtons, EditPanelCell, EditPanelInput, EditPanelRow, Panel, PanelBody } from '../../elements';

export function EditNominalValue(props: { projectId: string; projectName: string; onSaved: () => void }) {
    // const translate = useTranslate();
    const [isEditNominalDialogVisible, setIsEditNominalDialogVisible] = React.useState(false);

    const saveNominal = async (nominalValueUpdate?: number[]) => {
        await fetchPost(`/api/utProjectsNominals/${props.projectId}`, undefined, {
            nominalPositionWidthValues: JSON.stringify(nominalValueUpdate),
        });
        setIsEditNominalDialogVisible(false);
        props.onSaved();
    };

    return (
        <>
            <EditPanelButton text="Edit nominal" small onClick={() => setIsEditNominalDialogVisible(true)} />
            {isEditNominalDialogVisible && (
                <NominalValueForm
                    projectId={props.projectId}
                    projectName={props.projectName}
                    onClose={() => setIsEditNominalDialogVisible(false)}
                    onSave={saveNominal}
                />
            )}
        </>
    );
}

function NominalValueForm(props: { projectId: string; projectName: string; onClose: () => void; onSave: (nominalValueUpdate?: number[]) => void }) {
    const translate = useTranslate();
    const [nominalValue, setNominalValue] = React.useState<number[]>([]);
    const [totalPositions, setTotalPositions] = React.useState(0);

    const handleSingleChange = (positionIndex: number, value: string) => {
        const newValue: number[] = [];
        const length = totalPositions ?? 0;

        for (let i = 0; i < length; i++) {
            if (i === positionIndex && !isNaN(Number(value))) {
                newValue.push(Number(value));
            } else {
                newValue.push(nominalValue?.[i] ?? 0);
            }
        }
        setNominalValue(newValue);
    };

    React.useEffect(() => {
        void (async () => {
            const response = await fetchGet(`/api/utprojects/${props.projectId}`);
            if (response.json) {
                setNominalValue(response.json.nominalPositionWidthValues);
                setTotalPositions(response.json.maxScanLinePositions);
            }
        })();
    }, [props.projectId]);

    const handleCloseFormClicked = () => {
        props.onClose();
    };

    return (
        <Modal id="copy-dialog" onClose={() => handleCloseFormClicked()}>
            <Modal.Title>
                <h3>
                    <span className="panel-title">{`Edit nominal values ${props.projectName}`}</span>
                </h3>
            </Modal.Title>
            <Modal.Content style={{ height: '300px' }}>
                <form method="post" action="/" id="admin-form">
                    <Panel>
                        <div style={{ height: '260px', overflowY: 'scroll' }}>
                            <PanelBody>
                                <EditPanelRow>
                                    {range(totalPositions).map((i) => (
                                        <EditPanelCell rowCount={totalPositions < 3 ? 6 : 3} key={i}>
                                            <EditPanelInput
                                                name={`nominal${i + 1}`}
                                                restrictToNumbers
                                                topLabel={`Pos ${i + 1} `}
                                                value={nominalValue[i] ?? 0}
                                                handleChange={(value) => handleSingleChange(i, value)}
                                            />
                                        </EditPanelCell>
                                    ))}
                                </EditPanelRow>
                            </PanelBody>
                        </div>
                    </Panel>
                </form>
            </Modal.Content>
            <Modal.Actions>
                <EditPanelButtons fixWidth={true}>
                    <EditPanelButton small={true} text={translate('common.close')} onClick={() => handleCloseFormClicked()} />
                    <EditPanelButton small={true} text={translate('common.save')} onClick={() => props.onSave(nominalValue)} primary />
                </EditPanelButtons>
            </Modal.Actions>
        </Modal>
    );
}
